import { createSuitMixin as e } from "../mixins/suit.js";
export default {
  name: "SearchInput",
  mixins: [e({
    name: "SearchBox"
  })],
  props: {
    placeholder: {
      type: String,
      default: "Search here…"
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    showLoadingIndicator: {
      type: Boolean,
      default: !1
    },
    shouldShowLoadingIndicator: {
      type: Boolean,
      default: !1
    },
    ignoreCompositionEvents: {
      type: Boolean,
      default: !1
    },
    submitTitle: {
      type: String,
      default: "Search"
    },
    resetTitle: {
      type: String,
      default: "Clear"
    },
    value: {
      type: String,
      required: !1,
      default: void 0
    },
    modelValue: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  emits: ["input", "update:modelValue", "blur", "focus", "reset"],
  data: function data() {
    return {
      query: ""
    };
  },
  methods: {
    isFocused: function isFocused() {
      return document.activeElement === this.$refs.input;
    },
    onInput: function onInput(e) {
      this.ignoreCompositionEvents && e.isComposing || (this.$emit("input", e.target.value), this.$emit("update:modelValue", e.target.value));
    },
    onFormSubmit: function onFormSubmit() {
      this.$refs.input.blur();
    },
    onFormReset: function onFormReset() {
      this.$emit("input", ""), this.$emit("update:modelValue", ""), this.$emit("reset");
    }
  }
};